import { API } from 'src/api/API';
import { Context } from 'src/models/Context';
import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';
import produce from 'immer';

export const useDeleteCorporation = () => {
    const { isValidating, mutate, data, error } = useSWR<Context>(
        '/users/me',
        swrFetch,
    );

    const _delete = async (id: number) => {
        return new API().deleteCorporation(id).then(() => {
            mutate(
                produce(data, (data) => {
                    if (data?.corporations)
                        data.corporations = data.corporations.filter(
                            (v) => v.id !== id,
                        );

                    return data;
                }),
            );
        });
    };

    return [
        _delete,
        { isValidating, mutate, data: data?.corporations, error },
    ] as const;
};
